import { Injectable } from '@angular/core';
@Injectable()
export class PageMessagesService{
    messages = {
        modifySpecPage:{
            changeIsActiveAddNew:{
                    title:"Confirm Change",subtitle:"Deactivate Old Tolerance",
                    message:"There is currently an active tolerance with the same master band ID. Do you want the new one to be the active one instead"
            }
            ,changeAggregateType:{
                title:"Confirm Change",subtitle:"Aggregate Type",
                message:"the new aggregate type you are changing to has a diffrent sieve set and all the current tolerances will be lost."
        }
        }
    };

    // public getMessage(page:string,message:string):{title:string,subtitle:string,message:string}{
    //     return this.messages[page][message];
    // }

}